import {type} from '@ibe/store/util';
import {Action} from '@ngrx/store';
import {INDRABookedTripDetails} from '@ibe.models/booked-trip-details.indra.model.lib';
import {INDRAEmergencyData, INDRAPax, INDRATravelInsurance} from '@ibe.models/pax.indra.model.lib';
import {PassengerTravelDocument} from '@ibe.models/passenger.model';

export const ActionTypes = {
	LOADING: type('[PassengersDetails] LOADING'),
	PUT_BOOKEDTRIP_PASSENGERS_DETAILS: type('[PassengersDetails] PUT_BOOKEDTRIP_PASSENGERS_DETAILS'),
	LOAD_DOCUMENT_TYPES: type('[PassengersDetails] LOAD_DOCUMENT_TYPES'),
	LOAD_DOCUMENT_TYPES_SUCCESS: type('[PassengersDetails] LOAD_DOCUMENT_TYPES_SUCCESS'),
	LOAD_FREQUENT_FLYER_PROGRAMS: type('[PassengersDetails] LOAD_FREQUENT_FLYER_PROGRAMS'),
	LOAD_FREQUENT_FLYER_PROGRAMS_SUCCESS: type('[PassengersDetails] LOAD_FREQUENT_FLYER_PROGRAMS_SUCCESS'),
	UPDATE_FORM_CHANGED: type('[PassengersDetails] UPDATE_FORM_CHANGED'),
	HIDE_NOTIFICATION: type('[PassengersDetails] HIDE_NOTIFICATION'),
	SAVE_PASSENGER: type('[PassengerDetails] SAVE_PASSENGER'),
	SAVE_NEW_PASSENGER: type('[PassengerDetails] SAVE_NEW_PASSENGER'),
	SAVE_PASSENGER_SUCCESS: type('[PassengerDetails] SAVE_PASSENGER_SUCCESS'),
	SAVE_PASSENGER_ERRORS: type('[PassengersDetails] SAVE_PASSENGERS_ERRORS'),
	CANCEL_EDITING: type('[PassengersDetails] CANCEL_EDITING'),
	LOAD_COMPANION_LIST: type('[PassengersDetails] LOAD_COMPANION_LIST'),
}

export class LoadingAction implements Action {
	readonly type = ActionTypes.LOADING;

	constructor(public payload?) {}
}

export class PutBookedTripPassengersDetailsAction implements Action {
	readonly type = ActionTypes.PUT_BOOKEDTRIP_PASSENGERS_DETAILS;

	constructor(public payload: INDRABookedTripDetails) {}
}


export class LoadDocumentTypes implements Action {
	readonly type = ActionTypes.LOAD_DOCUMENT_TYPES;

	constructor(public payload?) { }
}

export class LoadDocumentTypesSuccess implements Action {
	readonly type = ActionTypes.LOAD_DOCUMENT_TYPES_SUCCESS;

	constructor(public payload: any) {}
}

export class LoadFrequentFlyerPrograms implements Action {
	readonly type = ActionTypes.LOAD_FREQUENT_FLYER_PROGRAMS;

	constructor(public payload?) { }
}

export class LoadCompanionList implements Action {
	readonly type = ActionTypes.LOAD_COMPANION_LIST;

	constructor(public payload?) { }
}

export class LoadFrequentFlyerProgramsSuccess implements Action {
	readonly type = ActionTypes.LOAD_FREQUENT_FLYER_PROGRAMS_SUCCESS;

	constructor(public payload: any) {}
}


export class UpdateFormChangedAction implements Action {
	readonly type = ActionTypes.UPDATE_FORM_CHANGED;

	constructor(public payload: { [key: string]: boolean; }) {}
}

export class HideNotificationAction implements Action {
	readonly type = ActionTypes.HIDE_NOTIFICATION;

	constructor(public payload?) {}
}

export class SavePassenger implements Action {
	readonly type = ActionTypes.SAVE_PASSENGER;

	constructor(
		public payload: {
			updateEmergencyContact: boolean,
			updateDoca: boolean,
			updateRedress: boolean,
			updateDocument: boolean,
			updateFrequentFlyer: boolean,
			updateContact: boolean,
			emergencyContact: INDRAEmergencyData,
			travelDocument: PassengerTravelDocument,
			frequentFlyer: INDRAPax,
			contact: INDRAPax
		},
		public pnr: string,
		public passenger_id: number
	) { }
}

export class SaveNewPassenger implements Action {
	readonly type = ActionTypes.SAVE_NEW_PASSENGER;

	constructor(
		public payload: {
			updateMainInfo: boolean,
			updateDoca: boolean,
			updateRedress: boolean,
			updateDocument: boolean,
			updateEmergencyContact: boolean,
			updateStudentInfo: boolean,
			updateResidentInfo: boolean,
			updateFrequentFlyer: boolean,
			updateTravelInsurance: boolean,
			updateContact: boolean,
			updateWorkInfo: boolean,
			emergencyContact: INDRAEmergencyData,
			travelDocument: PassengerTravelDocument,
			frequentFlyer: INDRAPax,
			travelInsurance: INDRATravelInsurance,
			contact: INDRAPax,
			mainInfo: INDRAPax,
			studentInfo: INDRAPax,
			residentInfo: INDRAPax,
			workInfo: INDRAPax
		},
		public passenger_id: number,
		public passenger_type: string
	) { }
}

export class SavePassengerSuccess implements Action {
	readonly type = ActionTypes.SAVE_PASSENGER_SUCCESS;

	constructor(public payload?: any) {}
}

export class SavePassengerErrors implements Action {
	readonly type = ActionTypes.SAVE_PASSENGER_ERRORS;

	constructor(public payload?: any) {}
}

export class CancelEditing implements Action {
	readonly type = ActionTypes.CANCEL_EDITING;

	constructor(public payload?: any) { }
}

export type Actions = LoadingAction
	| PutBookedTripPassengersDetailsAction
	| LoadDocumentTypes
	| LoadDocumentTypesSuccess
	| LoadFrequentFlyerPrograms
	| LoadFrequentFlyerProgramsSuccess
	| UpdateFormChangedAction
	| HideNotificationAction
	| SavePassenger
	| SaveNewPassenger
	| SavePassengerSuccess
	| SavePassengerErrors
	| CancelEditing
	;
